var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirmPdf1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ICON/COMMON/ETC/ic_common_etc_download"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 40935",
    d: "M8.5 9H6V19H18V9H15.5",
    stroke: "#1B1E28",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1221",
    d: "M12 4V14.5M12 14.5L9.5 12M12 14.5L14.5 12",
    stroke: "#1B1E28",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmPdf1);
export default __webpack_public_path__ + "static/media/confirmPDF_1.61c4f2b89bec090f2b03fd06bfd77279.svg";
export { ForwardRef as ReactComponent };